import { serverInfo } from "../config/serverConfig";
import { copyTextToClipboard } from "../utils/copyTextToClipboard";

/**
 * Canonical registration / marketing URL from the API (vanity `/e/{slug}` when available).
 * Public endpoint — no auth required.
 */
export async function fetchEventRegistrationUrl({ eventId, accountId, origin } = {}) {
  const id = eventId != null ? String(eventId).trim() : "";
  const account = accountId != null ? String(accountId).trim() : "";
  if (!id || !account) {
    throw new Error("Event and account are required to build a registration link.");
  }
  const resp = await fetch(`${serverInfo.serverUrl.replace(/\/$/, "")}/getEventRegistrationUrl`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      eventId: id,
      accountId: account,
      ...(origin ? { baseUrl: origin } : {}),
    }),
  });
  const text = await resp.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = null;
  }
  if (!resp.ok) {
    const msg = (data && data.error) || text || "Could not get registration link.";
    throw new Error(msg);
  }
  const url = data && data.registrationUrl ? String(data.registrationUrl).trim() : "";
  if (!url) {
    throw new Error("Registration link was empty.");
  }
  return url;
}

export async function copyEventRegistrationUrl({ eventId, accountId, origin } = {}) {
  const url = await fetchEventRegistrationUrl({ eventId, accountId, origin });
  const ok = await copyTextToClipboard(url);
  if (!ok) {
    throw new Error("Could not copy registration link.");
  }
  return url;
}
